import { render, staticRenderFns } from "./13-copy.vue?vue&type=template&id=4c00da74&scoped=true&"
import script from "./13-copy.vue?vue&type=script&lang=js&"
export * from "./13-copy.vue?vue&type=script&lang=js&"
import style0 from "./13-copy.vue?vue&type=style&index=0&id=4c00da74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c00da74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c00da74')) {
      api.createRecord('4c00da74', component.options)
    } else {
      api.reload('4c00da74', component.options)
    }
    module.hot.accept("./13-copy.vue?vue&type=template&id=4c00da74&scoped=true&", function () {
      api.rerender('4c00da74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/13-copy.vue"
export default component.exports